import Chart from "react-apexcharts";

const TestsChart = ({ data }) => {
  if (!data || data.length === 0) {
    return <div className="text-center text-muted">No data available</div>;
  }

  const chartData = {
    series: [{
      name: 'Tests',
      data: data.slice(-14).map(item => item.TOTAL_COUNT)
    }],
    options: {
      chart: {
        type: 'area',
        toolbar: { show: false },
        zoom: { enabled: false }
      },
      dataLabels: { enabled: false },
      stroke: {
        curve: 'smooth',
        width: 2
      },
      fill: {
        type: 'gradient',
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.7,
          opacityTo: 0.3
        }
      },
      xaxis: {
        categories: data.slice(-14).map(item => 
          new Date(item.TEST_DATE).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
        )
      },
      colors: ['#0d6efd'],
      tooltip: {
        y: {
          formatter: (val) => `${val} tests`
        }
      }
    }
  };

  return <Chart options={chartData.options} series={chartData.series} type="area" height={300} />;
};

export default TestsChart;